import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataCollectCardData } from '@onefootprint/request-types/dashboard';
import { Form } from '@onefootprint/ui';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import useDirty from '../../hooks/use-dirty';
import BaseNode, { type ApplyEditMutation } from '../base-node';
type CollectCardFormData = {
  cardAlias: string;
  nameOnCard: boolean;
  creditCardNumber: boolean;
  securityCode: boolean;
  expirationDate: boolean;
  billingZipCode: boolean;
  billingCountry: boolean;
};
const CollectCardNode = node => {
  const $ = _c(7);
  let t0;
  if ($[0] !== node.data || $[1] !== node.id) {
    t0 = {
      render: t1 => {
        const {
          mutation,
          canEdit
        } = t1;
        return <Content mutation={mutation} nodeId={node.id} nodeData={node.data} canEdit={canEdit} />;
      },
      form: "collect-card-form"
    };
    $[0] = node.data;
    $[1] = node.id;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== node.data || $[4] !== node.id || $[5] !== t0) {
    t1 = <BaseNode nodeId={node.id} data={node.data} sidebar={t0} />;
    $[3] = node.data;
    $[4] = node.id;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
const Content = t0 => {
  const $ = _c(87);
  const {
    canEdit,
    mutation,
    nodeData,
    nodeId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCard"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    toggle
  } = useDirty();
  const t2 = nodeData.cardAliasOptions?.static || "";
  const t3 = nodeData.collectionOptions?.cvcRequired || false;
  const t4 = nodeData.collectionOptions?.expirationRequired || false;
  const t5 = nodeData.collectionOptions?.billingZipRequired || false;
  const t6 = nodeData.collectionOptions?.billingCountryRequired || false;
  let t7;
  if ($[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = {
      defaultValues: {
        cardAlias: t2,
        nameOnCard: true,
        creditCardNumber: true,
        securityCode: t3,
        expirationDate: t4,
        billingZipCode: t5,
        billingCountry: t6
      }
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const methods = useForm(t7);
  const {
    handleSubmit,
    formState: t8
  } = methods;
  const {
    isDirty
  } = t8;
  let t9;
  if ($[7] !== isDirty || $[8] !== toggle) {
    t9 = () => {
      toggle("collect-card", isDirty);
    };
    $[7] = isDirty;
    $[8] = toggle;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isDirty) {
    t10 = [isDirty];
    $[10] = isDirty;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  useEffect(t9, t10);
  let t11;
  if ($[12] !== mutation || $[13] !== nodeId) {
    t11 = async data => {
      ;
      try {
        await mutation.mutateAsync({
          nodeId,
          kind: "update_node",
          nodeData: {
            kind: "collect_card_data",
            cardAliasOptions: {
              static: data.cardAlias
            },
            collectionOptions: {
              billingCountryRequired: data.billingCountry,
              billingZipRequired: data.billingZipCode,
              cvcRequired: data.securityCode,
              expirationRequired: data.expirationDate
            }
          }
        });
      } catch (t12) {
        const _ = t12;
      }
    };
    $[12] = mutation;
    $[13] = nodeId;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const handleFormSubmit = t11;
  let t12;
  if ($[15] !== handleFormSubmit || $[16] !== handleSubmit) {
    t12 = handleSubmit(handleFormSubmit);
    $[15] = handleFormSubmit;
    $[16] = handleSubmit;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t) {
    t13 = t(_temp);
    $[18] = t;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <div className="text-body-2 text-primary">{t13}</div>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = !canEdit;
  let t16;
  if ($[22] !== t) {
    t16 = t(_temp2);
    $[22] = t;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t) {
    t17 = t(_temp3);
    $[24] = t;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t) {
    t18 = t(_temp4);
    $[26] = t;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t18) {
    t19 = {
      required: t18
    };
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t15 || $[31] !== t16 || $[32] !== t17 || $[33] !== t19) {
    t20 = <Form.Input name="cardAlias" disabled={t15} label={t16} placeholder={t17} size="compact" rules={t19} />;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t) {
    t21 = t(_temp5);
    $[35] = t;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21) {
    t22 = <div className="text-label-2 text-primary">{t21}</div>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t) {
    t23 = t(_temp6);
    $[39] = t;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t23) {
    t24 = <Form.Checkbox name="nameOnCard" label={t23} disabled={true} />;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t) {
    t25 = t(_temp7);
    $[43] = t;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t25) {
    t26 = <Form.Checkbox name="creditCardNumber" label={t25} disabled={true} />;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t) {
    t27 = t(_temp8);
    $[47] = t;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  const t28 = !canEdit;
  let t29;
  if ($[49] !== t27 || $[50] !== t28) {
    t29 = <Form.Checkbox name="securityCode" label={t27} disabled={t28} />;
    $[49] = t27;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t) {
    t30 = t(_temp9);
    $[52] = t;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  const t31 = !canEdit;
  let t32;
  if ($[54] !== t30 || $[55] !== t31) {
    t32 = <Form.Checkbox name="expirationDate" label={t30} disabled={t31} />;
    $[54] = t30;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t) {
    t33 = t(_temp10);
    $[57] = t;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  const t34 = !canEdit;
  let t35;
  if ($[59] !== t33 || $[60] !== t34) {
    t35 = <Form.Checkbox name="billingZipCode" label={t33} disabled={t34} />;
    $[59] = t33;
    $[60] = t34;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] !== t) {
    t36 = t(_temp11);
    $[62] = t;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  const t37 = !canEdit;
  let t38;
  if ($[64] !== t36 || $[65] !== t37) {
    t38 = <Form.Checkbox name="billingCountry" label={t36} disabled={t37} />;
    $[64] = t36;
    $[65] = t37;
    $[66] = t38;
  } else {
    t38 = $[66];
  }
  let t39;
  if ($[67] !== t24 || $[68] !== t26 || $[69] !== t29 || $[70] !== t32 || $[71] !== t35 || $[72] !== t38) {
    t39 = <div className="flex flex-col gap-3">{t24}{t26}{t29}{t32}{t35}{t38}</div>;
    $[67] = t24;
    $[68] = t26;
    $[69] = t29;
    $[70] = t32;
    $[71] = t35;
    $[72] = t38;
    $[73] = t39;
  } else {
    t39 = $[73];
  }
  let t40;
  if ($[74] !== t22 || $[75] !== t39) {
    t40 = <div className="flex flex-col gap-4">{t22}{t39}</div>;
    $[74] = t22;
    $[75] = t39;
    $[76] = t40;
  } else {
    t40 = $[76];
  }
  let t41;
  if ($[77] !== t14 || $[78] !== t20 || $[79] !== t40) {
    t41 = <div className="px-5 py-4 border rounded bg-primary border-tertiary flex flex-col gap-6">{t14}{t20}{t40}</div>;
    $[77] = t14;
    $[78] = t20;
    $[79] = t40;
    $[80] = t41;
  } else {
    t41 = $[80];
  }
  let t42;
  if ($[81] !== t12 || $[82] !== t41) {
    t42 = <form id="collect-card-form" onSubmit={t12}>{t41}</form>;
    $[81] = t12;
    $[82] = t41;
    $[83] = t42;
  } else {
    t42 = $[83];
  }
  let t43;
  if ($[84] !== methods || $[85] !== t42) {
    t43 = <FormProvider {...methods}>{t42}</FormProvider>;
    $[84] = methods;
    $[85] = t42;
    $[86] = t43;
  } else {
    t43 = $[86];
  }
  return t43;
};
export default CollectCardNode;
function _temp($) {
  return $.instructions;
}
function _temp2($_0) {
  return $_0.form.cardAlias.title;
}
function _temp3($_1) {
  return $_1.form.cardAlias.placeholder;
}
function _temp4($_2) {
  return $_2.form.cardAlias.required;
}
function _temp5($_3) {
  return $_3.form.fieldsToCollect.title;
}
function _temp6($_4) {
  return $_4.form.fieldsToCollect.nameOnCard;
}
function _temp7($_5) {
  return $_5.form.fieldsToCollect.creditCardNumber;
}
function _temp8($_6) {
  return $_6.form.fieldsToCollect.securityCode;
}
function _temp9($_7) {
  return $_7.form.fieldsToCollect.expirationDate;
}
function _temp10($_8) {
  return $_8.form.fieldsToCollect.billingZipCode;
}
function _temp11($_9) {
  return $_9.form.fieldsToCollect.billingCountry;
}